import React, { createContext, useContext } from 'react';

const BatteryInfoContext = createContext();
const BatteryConfigContext = createContext();
const BatteryStructureContext = createContext();
const BatterySystemContext = createContext();
const VehicleInfoContext = createContext();

export function DigitalTwinProvider({ children, value }) {
    return (
        <BatteryInfoContext.Provider value={{
            batteryID: value.batteryID,
            batteryInfo: value.batteryInfo,
            setBatteryInfo: value.setBatteryInfo,
            showBusDeviceInfo: value.showBusDeviceInfo,
            pageType: value.pageType,
            operationalStatusVersion: value.operationalStatusVersion,
            refreshOperationalStatus: value.refreshOperationalStatus,
        }}>
            <BatteryConfigContext.Provider value={value.batteryConfig}>
                <BatteryStructureContext.Provider value={value.batteryStructure}>
                    <BatterySystemContext.Provider value={value.batterySystem}>
                        <VehicleInfoContext.Provider value={{
                            ...value.vehicleInfo,
                            setVehicleInfo: value.setVehicleInfo,
                        }}>
                            {children}
                        </VehicleInfoContext.Provider>
                    </BatterySystemContext.Provider>
                </BatteryStructureContext.Provider>
            </BatteryConfigContext.Provider>
        </BatteryInfoContext.Provider>
    );
}

export function useBatteryInfo() {
    const context = useContext(BatteryInfoContext);
    if (context === undefined) {
        throw new Error('useBatteryInfo must be used within a DigitalTwinProvider');
    }
    return context;
}

export function useVehicleInfo() {
    const context = useContext(VehicleInfoContext);
    if (context === undefined) {
        throw new Error('useVehicleInfo must be used within a DigitalTwinProvider');
    }
    return context;
}

export function useBatteryConfig() {
    const context = useContext(BatteryConfigContext);
    if (context === undefined) {
        throw new Error('useBatteryConfig must be used within a DigitalTwinProvider');
    }
    return context;
}

export function useBatteryStructure() {
    const context = useContext(BatteryStructureContext);
    if (context === undefined) {
        throw new Error('useBatteryStructure must be used within a DigitalTwinProvider');
    }
    return context;
}

export function useBatterySystem() {
    const context = useContext(BatterySystemContext);
    if (context === undefined) {
        throw new Error('useBatterySystem must be used within a DigitalTwinProvider');
    }
    return context;
}
